import React, { FC } from 'react';
import Hero from './Hero';
import Services from './Services';
import styled from 'styled-components';
import { useScreenClass } from 'react-grid-system';

const HeroSection = styled.section`
  background-color: ${(props) => props.theme.colors.darkRed};
  height: auto;
  overflow: hidden;
`;

const ServicesSection = styled.section<{ isDesktop: boolean }>`
  background-color: #ffffff;
  padding: ${(props) => (props.isDesktop ? '3.75rem 6rem 2.25rem' : '2.5rem 1rem 1.5rem')};
`;

const HeroWrapper: FC = () => {
  const screenClass = useScreenClass();
  const isDesktop = ['lg', 'xl'].includes(screenClass);

  return (
    <>
      <HeroSection>
        <Hero />
      </HeroSection>
      <ServicesSection isDesktop={isDesktop}>
        <Services />
      </ServicesSection>
    </>
  );
};

export default HeroWrapper;
